const padNumber = (x: number) => x.toString().padStart(2, '0');

export function calculateMinDate() {
  const d = new Date();

  return `${d.getFullYear()}-${padNumber(d.getMonth() + 1)}-${padNumber(
    d.getDate(),
  )}`;
}
